export const config = {
  url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vS-uKTf7Gw7htjenTm5KgqmYAzCNAlliLi_h0zCm9Ey7ZDY4lJn92Qkp4U8MwMjW-AL7Ckk5IBUjFcQ/pub?gid=944190457&single=true&output=csv",
  // title: "Virginia Tech Authors 2019-2022",
  // description: "A listing of all of the publications by Virginia Tech employees over the last 3 years",
  searchFields: [
    "First Name",
    "Last Name",
    "Editors",
    "Department",
    "College",
    "Title",
    "Publisher",
    "Year Published",
  ],
  headers: [
    {
      key: "First Name",
      value: "First Name",
    },
    {
      key: "Last Name",
      value: "Last Name",
    },
    {
      key: "Editors",
      value: "Co-Authors/Co-Editors",
    },
    {
      key: "Department",
      value: "Department",
    },
    {
      key: "College",
      value: "College",
    },
    {
      key: "Title",
      value: "Title",
    },
    {
      key: "Publisher",
      value: "Publisher",
    },
    {
      key: "Year Published",
      value: "Year Published",
    },
  ],
  link: false,
};
